import { useOptionalDispositiveDiagramSyncContext } from '@/modules/dispositiveProvisions/contexts/DispositiveDiagramSync.context';
import { useHouseholdDetailsContext } from '@/modules/household/contexts/householdDetails.context';

import { useOptionalBeneficiaryDesignationsFormContext } from '../contexts/beneficiaryDesignationsForm.context';

/**
 * The decedent whose beneficiary designations take effect, used for
 * recipient-type defaulting. Mirrors how the BDG form picks its active
 * scenario: the selected death-order client, else the default trigger client,
 * else the retirement account's owner, else the first primary client.
 *
 * The account owner is sourced from the entity itself (not the diagram), so a
 * spouse beneficiary still defaults to the marital deduction when the diagram
 * sync state is unavailable (e.g. editing from the entity overview rather than
 * the waterfall split-screen) and the owner isn't primaryClients[0].
 *
 * Shared by the per-recipient default hook and the split modal so both default
 * recipient types against the same decedent.
 */
export function useBdgDyingClientId(): string | null {
  const { primaryClients } = useHouseholdDetailsContext();
  const syncContext = useOptionalDispositiveDiagramSyncContext();
  const bdg = syncContext?.bdgDiagramSyncState ?? null;
  const accountDecedentClientId =
    useOptionalBeneficiaryDesignationsFormContext()?.accountDecedentClientId ??
    null;

  return (
    bdg?.selectedPrimaryClientId ??
    bdg?.defaultTriggerClientId ??
    accountDecedentClientId ??
    primaryClients?.[0]?.id ??
    null
  );
}
